import {
  MYACCOUNT_REQUESTING,
  MYACCOUNT_REQUEST_SUCCESS,
  MYACCOUNT_REQUEST_ERROR,
  MYACCOUNT_POST_REQUESTING,
  MYACCOUNT_POST_SUCCESS,
  MYACCOUNT_POST_ERROR,
} from './constants'

const initialState = {
  type: MYACCOUNT_REQUESTING,
  data:{}, // where we'll store widgets
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  postData: {},
}

const reducer = function myaccountReducer (state = initialState, action) {
  switch (action.type) {

    case MYACCOUNT_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data:{}, // where we'll store widgets
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
        postData: {},
      }

    case MYACCOUNT_REQUEST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data: action.profile, // replace with fresh list
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case MYACCOUNT_REQUEST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data:{}, // where we'll store widgets
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

      case MYACCOUNT_POST_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data:{}, // where we'll store widgets
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
        postData: action.payload,
      }

    case MYACCOUNT_POST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data: {}, // replace with fresh list
        requesting: false,
        successful: true,
        messages:  [{ body: action.data.message, time: new Date() }],
        errors: [],
      }

    case MYACCOUNT_POST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        data:{}, // where we'll store widgets
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/MyAccount/reducer.js